import {
	createStyles,
	makeStyles
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		newBusinessApplicationNavigation_container: {
			margin: theme.spacing(2, 0, 1, 0),
			display: 'flex',
			flexDirection: 'column',
		},
		newBusinessApplicationNavigation_hide: {
			padding: theme.spacing(0, 2, 0, 2),
			display: 'flex',
		},
		newBusinessApplicationNavigation_hideLabel: {
			color: theme.palette.grey[400],
			cursor: 'pointer',
		},
		newBusinessApplicationNavigation_hideButton: {
			color: theme.palette.grey[400],
			padding: theme.spacing(0),
			marginLeft: theme.spacing(.5),
		},
		newBusinessApplicationNavigation_stepper: {
			padding: theme.spacing(2),
		},
		newBusinessApplicationNavigation_expandButton: {
			color: theme.palette.info.main,
			padding: theme.spacing(0),
			marginLeft: theme.spacing(.5),
		},
		newBusinessApplicationNavigation_stepLabel: {
			padding: theme.spacing(0),
		},
		newBusinessApplicationNavigation_stepLabelText: {
			color: `${theme.palette.info.main}`,
			fontWeight: `${theme.typography.fontWeightLight} !important` as any,
			cursor: 'pointer',
			userSelect: 'none',
		},
		newBusinessApplicationNavigation_stepLabelTextActive: {
			'& $newBusinessApplicationNavigation_stepLabelText': {
				color: `${theme.palette.info.main} !important`,
			},
			fontWeight: `${theme.typography.fontWeightBold} !important` as any,
		},
		newBusinessApplicationNavigation_stepLabelTextCompleted: {
			'& $newBusinessApplicationNavigation_stepLabelText': {
				color: `${theme.palette.info.main} !important`,
			},
		},
		newBusinessApplicationNavigation_stepLabelTextDisabled: {
			'& $newBusinessApplicationNavigation_stepLabelText': {
				color: `${theme.palette.grey[400]} !important`,
				cursor: 'default',
			},
		},
		newBusinessApplicationNavigation_stepLabelIcon: {
			fontSize: theme.spacing(2.5),
			color: `${theme.palette.info.main}`,
		},
		newBusinessApplicationNavigation_stepLabelIconActive: {
			fontSize: theme.spacing(2.5),
			color: `${theme.palette.info.main} !important`,
		},
		newBusinessApplicationNavigation_stepLabelIconComplete: {
			fontSize: theme.spacing(2.5),
			color: `${theme.palette.success.main} !important`,
		},
		newBusinessApplicationNavigation_stepLabelIconDisabled: {
			fontSize: theme.spacing(2.5),
			color: `${theme.palette.grey[400]} !important`,
		},
		newBusinessApplicationNavigation_stepConnector: {
			'& $newBusinessApplicationNavigation_stepConnectorLine': {
				borderColor: theme.palette.info.main,
			},
			margin: theme.spacing(0, 0, .5, 1.25),
			padding: theme.spacing(0),
		},
		newBusinessApplicationNavigation_stepConnectorComplete: {
			'& $newBusinessApplicationNavigation_stepConnectorLine': {
				borderColor: theme.palette.success.main,
			},
			margin: theme.spacing(0, 0, .5, 1.25),
			padding: theme.spacing(0),
		},
		newBusinessApplicationNavigation_stepConnectorDisabled: {
			'& $newBusinessApplicationNavigation_stepConnectorLine': {
				borderColor: theme.palette.grey[400],
			},
			margin: theme.spacing(0, 0, .5, 1.25),
			padding: theme.spacing(0),
		},
		newBusinessApplicationNavigation_stepConnectorLine: {
			height: theme.spacing(2),
			minHeight: theme.spacing(2),
		},
		newBusinessApplicationNavigation_stepContent: {
			margin: theme.spacing(.5, 0, 0, 1.25),
			borderColor: theme.palette.info.main,
		},
		newBusinessApplicationNavigation_stepContentComplete: {
			borderColor: theme.palette.success.main,
			margin: theme.spacing(.5, 0, 0, 1.25),
		},
		newBusinessApplicationNavigation_stepContentDisabled: {
			borderColor: theme.palette.grey[400],
			margin: theme.spacing(.5, 0, 0, 1.25),
		},
		newBusinessApplicationNavigation_progressWrapper: {
			position: 'relative',
			display: 'inline-flex',
			width: '100%',
			justifyContent: 'center',
		},
		newBusinessApplicationNavigation_progressCircle: {
			width: `${theme.spacing(18)} !important`,
			height: `${theme.spacing(18)} !important`,
		},
		newBusinessApplicationNavigation_progressLabelWrapper: {
			position: 'absolute',
			top: theme.spacing(0),
			bottom: theme.spacing(0),
			left: theme.spacing(0),
			right: theme.spacing(0),
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
		},
		newBusinessApplicationNavigation_progressLabel: {
			display: 'flex',
			justifyContent: 'center',
			fontSize: theme.spacing(4),
			color: theme.palette.grey[400],
			cursor: 'pointer',
		},
		newBusinessApplicationNavigation_progressSubLabel: {
			paddingTop: theme.spacing(1),
			fontSize: theme.spacing(2),
			color: theme.palette.grey[400],
			cursor: 'pointer',
		},
		newBusinessApplicationNavigation_progressOpenButton: {
			color: theme.palette.grey[400],
			padding: theme.spacing(0),
			marginLeft: theme.spacing(.5),
		}
	});
});

export default useStyles;
